export const useQuery = (...params: string[]) => {
  const searchParams = new URLSearchParams(globalThis.location.search);
  return params.map((param) => searchParams.get(param));
};
